import { Flex } from 'antd';
import { Signup } from '../../auth-user/signup';
import styles from '../navbar.module.scss';
import { useNavigate } from 'react-router-dom';
import { USER_BASE_PATH } from '../../../constants/user-paths';

const SignupSection = ({ signupRef }) => {
  const navigate = useNavigate();

  const handleLogin = () => navigate(USER_BASE_PATH);

  return (
    <div style={{ backgroundColor: '#f8f8f8' }} className={styles.signupSection}>
      <div ref={signupRef} className={styles.signupWrap}>
        <Signup handleLogin={handleLogin} />
      </div>
    </div>
  );
};

export default SignupSection;
